import React, { useState, useEffect } from "react";
import FirstCardSection from "./First-Card-Section";

import RoomDetailsCard from "./Room-Details-Card";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getProfile } from "../../../../redux/slices/sliceActions";
import PropertyCard from "./PropertyCard";



const RightSectionPc = () => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id =user?.data?.id;

  const [profileUpdated, setProfileUpdated] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState([]);
  const [landlordDetails, setLandlordDetails] = useState([]);
  const [paymentProgressInvoices, setPaymentProgressInvoices] = useState([]);
  const [paymentProgressPayments, setPaymentProgressPayments] = useState([]);

  useEffect(() => {
    console.log('user', user);
    if (Object.keys(user).length > 0 && !profileUpdated) {
      dispatch(getProfile({ userId:id })).then((res) => {
        console.log("profile update", res);
        setProfileUpdated(true);
        setPropertyDetails({
          propertyName: res?.payload?.property_name || "Not Available",
          propertyLocation: res?.payload?.property_location || "Not Available",
          waterCharge: res?.payload?.water_charge   || "Not Available",
          totalTenants: res?.payload?.occupiedHouses || "Not Available",
          garbageCharge: res?.payload?.garbage_charges || "Not Available",
        });
        setLandlordDetails({
          name: res?.payload?.landlord_name || "Not Available",
          phone: res?.payload?.landlord_phone_number || "Not Available",
          profilePhoto: res?.payload?.landlord_profile_photo || "Not Available",
        });
        setPaymentProgressInvoices(res?.payload?.unpaidInvoices);
        setPaymentProgressPayments(res?.payload?.paidInvoices?.[0]);
     
        // setHouseDetails(res?.payload?.tenant_details.house_info);
        // setCareTakerDetails(res?.payload?.tenant_details.caretaker);
        // 
        // 
      });
    }
   
  }, [user]);

  return (
    <div style={{ width: "100%",height:"100%" }}>
      <div className="first-card-section" style={{ width: "100%",height:"100%" }}>
        <PropertyCard/>
        {/* <FirstCardSection
          paymentProgressInvoices={paymentProgressInvoices}
          paymentProgressPayments={paymentProgressPayments}
          propertyDetails={propertyDetails}
        /> */}
        {/* <RoomDetailsCard
          propertyDetails={propertyDetails}
          landlordDetails={landlordDetails}
        /> */}
      </div>
    </div>
  );
};

export default RightSectionPc;
